import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import s from './RightSection.scss';
import CardComponent from '../OverlayCard/OverlayCard';

const truncateWords = str => {
  const words = 23;
  if (str && str.split(' ').length > words) {
    return str
      .split(' ')
      .splice(0, words)
      .join(' ');
  }
  return str;
};

const RightSection = ({
  isWapView,
  cardsData,
  synopsis,
  dataLoading,
  openModalClick,
  fireGA,
  hlts,
  msid,
}) => {
  const [showCards, setShowCards] = useState(false);
  const checkData = cards => {
    let returnedValue;
    for (let i = 0; i < Object.keys(cards).length; i += 1) {
      if (
        cards[Object.keys(cards)[i]].render_as === 'image' &&
        cards[Object.keys(cards)[i]].screenshot_url
      ) {
        returnedValue = (
          <img
            className={s.containerImg}
            src={cards[Object.keys(cards)[i]].screenshot_url}
            alt="card_image"
            width="300"
            height="90"
          />
        );
        break;
      } else {
        returnedValue = cards[Object.keys(cards)[i]].render_as === 'iframe' &&
          cards[Object.keys(cards)[i]].iframe && (
            <div
              /* eslint-disable react/no-danger */
              dangerouslySetInnerHTML={{
                __html: cards[Object.keys(cards)[i]].iframe,
              }}
            />
          );
        break;
      }
    }

    return returnedValue;
  };

  const getHltsData = hltsData =>
    hltsData.length > 0 && (
      <ul className={s.synopsisHglts}> {hltsData.map(el => <li>{el}</li>)}</ul>
    );

  useEffect(
    () => {
      if (Array.isArray(cardsData) && cardsData.length > 0) {
        for (let i = 0; i < Object.keys(cardsData[0]).length; i += 1) {
          if (
            cardsData[0][Object.keys(cardsData[0])[i]].render_as === 'image' &&
            cardsData[0][Object.keys(cardsData[0])[i]].screenshot_url
          ) {
            setShowCards(true);
            break;
          } else if (
            cardsData[0][Object.keys(cardsData[0])[i]].render_as === 'iframe' &&
            cardsData[0][Object.keys(cardsData[0])[i]].iframe
          ) {
            setShowCards(true);
            break;
          }
        }
      }
    },
    [cardsData[0]],
  );
  return (
    <>
      {(Array.isArray(cardsData) &&
        cardsData.length === 0 &&
        !(synopsis || (Array.isArray(hlts) && hlts?.length > 0))) ||
      (!(synopsis || (Array.isArray(hlts) && hlts?.length > 0)) &&
        !showCards) ? null : (
        <div className={s.wrapper}>
          <div className={s.whystorycontainer}>
            <h4 className={s.whythisstory}>Why this story</h4>
            {isWapView && (
              <span
                className={s.morereason}
                onClick={() => {
                  fireGA('Click_cards');
                  openModalClick();
                }}
              >
                Here&apos;s Why
              </span>
            )}
          </div>
          {!isWapView ? (
            <div className={s.cardscontainer}>
              {(synopsis || (Array.isArray(hlts) && hlts?.length > 0)) && (
                <div className={s.firstcard}>
                  {synopsis || getHltsData(hlts)}
                </div>
              )}
              <CardComponent
                cardsData={cardsData}
                isWapView={isWapView}
                dataLoading={dataLoading}
                msid={msid}
              />
            </div>
          ) : (
            <>
              {!(synopsis || (Array.isArray(hlts) && hlts?.length > 0)) &&
              Array.isArray(cardsData) &&
              cardsData.length > 0 ? (
                <div
                  onClick={() => {
                    fireGA('Click_cards');
                    openModalClick();
                  }}
                >
                  {checkData(cardsData[0])}
                </div>
              ) : (
                <div className={s.description}>
                  <div
                    className={s.synopsis}
                    onClick={() => {
                      openModalClick();
                    }}
                  >
                    {synopsis && truncateWords(synopsis)}
                    {synopsis &&
                      synopsis.split(' ').length > 23 && (
                        <>
                          ...
                          <span className={s.readMore}>Read More</span>
                        </>
                      )}
                    {Array.isArray(hlts) &&
                      hlts?.length > 0 &&
                      getHltsData(hlts)}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state, ownProps) => ({
  cardsData: state.toiplusprimeshow.cardsData,
  synopsis: state.toiplusprimeshow.data[ownProps.msid].syn,
  hlts: state.toiplusprimeshow.data[ownProps.msid]?.hlts,
  dataLoading: state.toiplusprimeshow.dataLoading,
});

RightSection.propTypes = {
  cardsData: PropTypes.arrayOf(
    PropTypes.objectOf(PropTypes.objectOf(PropTypes.string)),
  ),
  isWapView: PropTypes.bool,
  synopsis: PropTypes.string,
  dataLoading: PropTypes.bool,
  openModalClick: PropTypes.func,
  fireGA: PropTypes.func,
  hlts: PropTypes.arrayOf(PropTypes.string),
  msid: PropTypes.string,
};

RightSection.defaultProps = {
  cardsData: [],
  isWapView: false,
  synopsis: '',
  dataLoading: true,
  openModalClick: () => {},
  hlts: [],
  fireGA: () => {},
  msid: '',
};

export default connect(mapStateToProps, null)(RightSection);
